import tabType8 from "./tabType8";

export default tabType8;
